import { Typography, Collapse, Button, Box } from '@mui/material'
import React, { FC, useState } from 'react'
import { makeStyles } from 'tss-react/mui'

import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { J1ToparrowD } from '@e3dc-react/icons'

interface CollapsedPaperProps {
  title: string
  children?: React.ReactNode
}

const useStyles = makeStyles()(theme => ({
  paper: {
    paddingBottom: 0,
  },
  paperContainer: {
    paddingInline: theme.spacing(3),
  },
  collapseIcon: {
    transition: '0.2s',
  },
  collapseIconCollapsed: {
    rotate: '180deg',
  },
  childrenContainer: {
    paddingBottom: theme.spacing(4),
  },
}))

/**
 * Common collapse paper component for the elements on the components page
 */
const CollapsedPaper: FC<CollapsedPaperProps> = ({ title, children }) => {
  const [isExpanded, setExpanded] = useState(true)
  const { classes, cx } = useStyles()

  const switchExpandedStatus = (): void => {
    setExpanded(oldStatus => !oldStatus)
  }

  return (
    <Paper
      headerChildren={
        <Button variant="text" onClick={switchExpandedStatus}>
          <J1ToparrowD className={isExpanded ? classes.collapseIcon : cx(classes.collapseIcon, classes.collapseIconCollapsed)} />
        </Button>
      }
      title={<Typography fontWeight="500">{title}</Typography>}
      className={classes.paper}
    >
      <Box className={classes.paperContainer}>
        <Collapse in={isExpanded} timeout={200} unmountOnExit mountOnEnter>
          <Box className={classes.childrenContainer}>{children}</Box>
        </Collapse>
      </Box>
    </Paper>
  )
}

export default CollapsedPaper
